// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"528":"b355458d","703":"a4f5a15c","787":"aa3e29b5"}[chunkId] + ".chunk.js";
};